import { dataHospital } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHospital = /*#__PURE__*/createIcon(dataHospital)
export default IconHospital
